"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridContainer = _interopRequireDefault(require("../../../layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("../../../layouts/grid/GridItem"));

var _BoxSizing = _interopRequireDefault(require("../../../layouts/box/boxSizing/BoxSizing"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _Divider = _interopRequireDefault(require("../../../atoms/dividers/Divider"));

var _ButtonText = _interopRequireDefault(require("../../../atoms/buttons/buttonText/ButtonText"));

var _CardAction = _interopRequireDefault(require("../../cards/cardContainer/CardAction"));

var _Bar = _interopRequireDefault(require("../../../atoms/dataVisual/bar/Bar"));

var _CardContainer = _interopRequireDefault(require("../../cards/cardContainer/CardContainer"));

var _BlocksHero = _interopRequireDefault(require("../blocksHero/BlocksHero"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlocksHeroCarousel = function BlocksHeroCarousel(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    isSquare: true
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    alignItems: "center",
    disableGutters: true
  }, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_BlocksHero.default, {
      buttonText: item.buttonText,
      primaryText: item.primaryText,
      buttonAction: item.buttonAction
    }));
  }), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    color: "greyOne"
  })), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    pt: "large",
    pb: "xxl"
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_ButtonText.default, {
    action: function action() {},
    title: "Prev",
    icon: "ic_chevron__left",
    iconPos: "start"
  })), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "true"
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 3
    }, /*#__PURE__*/_react.default.createElement(_CardAction.default, {
      action: function action() {}
    }, /*#__PURE__*/_react.default.createElement(_Bar.default, {
      color: "error",
      value: 70
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      text: item.primaryText,
      bold: true
    })));
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_ButtonText.default, {
    action: function action() {},
    title: "Next",
    icon: "ic_chevron__right",
    iconPos: "end"
  })))))));
};

BlocksHeroCarousel.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    primaryText: _propTypes.default.string,
    imageUrl: _propTypes.default.string,
    buttonText: _propTypes.default.string,
    buttonAction: _propTypes.default.func.isRequired
  })).isRequired
};
BlocksHeroCarousel.defaultProps = {};
var _default = BlocksHeroCarousel;
exports.default = _default;